import BookingPage from "./BookingPage";
export default function TournamentRegistration() { return <BookingPage type="tournament" />; }
